import { css } from '@emotion/react'
import { ITableProps } from 'common-components'
import { ProjectAchievementType } from '@types'
import { Loader } from '@components/utils'

import ContributorsTable from './ContributorsTable'
import Header from './Header'

type ContributorsPropsType = {
  projectsAchievement: ProjectAchievementType[]
  tableProps?: Partial<ITableProps<ProjectAchievementType>>
  isLoading?: boolean
}
const Contributors = ({
  projectsAchievement,
  isLoading,
  tableProps = {},
}: ContributorsPropsType) => {
  return (
    <>
      <Header data={{}} />
      <div
        css={css`
          margin-top: 16px;
        `}
      >
        {isLoading && <Loader />}
        {!isLoading && (
          <ContributorsTable projectsAchievement={projectsAchievement} {...tableProps} />
        )}
      </div>
    </>
  )
}

export default Contributors
